import React, { useEffect, useState } from "react";
import { getCookie, setCookie } from "../../Shared/Utils";
import { translate } from "../../Services/translation";
import clsx from "clsx";

const Modal = ({ content }) => {
    const [open, setOpen] = useState(false);
    const [leaving, setLeaving] = useState(false);

    const onCloseHandler = () => {
        setLeaving(true);
        setCookie('modal-closed', '1');
        setTimeout(() => {
            setOpen(false);
            setLeaving(false);
        }, 400); // match animation duration
    };

    useEffect(() => {
        const cookie = !!parseInt(getCookie('modal-closed'));
        if (cookie) return;
        setOpen(true);
    }, []);

    return (
        <>
            <div className={clsx('modal', {
                'is-active': open && !leaving,
                'is-leaving': leaving
            })}>
                <div dangerouslySetInnerHTML={{ __html: content }}></div>
                <div className="modal-footer">
                    <button type="button" className="modal-close button muurikka-btn muurikka-btn--red" onClick={onCloseHandler}>{translate('muha.modal.button.close.text')}</button>
                </div>
            </div>
            <div className="modal-overlay"></div>
        </>
    );
}

export default Modal;
